import { render, staticRenderFns } from "./mypromise.vue?vue&type=template&id=54d1a1de&scoped=true"
import script from "./mypromise.vue?vue&type=script&lang=js"
export * from "./mypromise.vue?vue&type=script&lang=js"
import style0 from "./mypromise.vue?vue&type=style&index=0&id=54d1a1de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d1a1de",
  null
  
)

export default component.exports